import { useEffect, useState } from "react";
import styled from "styled-components/macro";
import {
  BoxContent,
  Box,
  BoxNavRight,
  BoxNavButton,
  BoxHeader,
  BoxTitle,
} from "../Box";
import Button from "../Button";
import Stack from "../Stack";
import usePlan from "../../hooks/use-plan";
import { useHistory } from "react-router";
import { StackingBoxModal } from "../StackingBox";
import { Close } from "../Icons";
import Bar from "../Bar";
import MessagesKeyframes from "../MessagesKeyframes";
import { useQuery } from "@tanstack/react-query";
import { fetchUser } from "../../api/users";

export default function IsOverPrompt() {
  const history = useHistory();
  const plan = usePlan();
  const user = useQuery({
    queryKey: ["users", "me"],
    queryFn: fetchUser,
    select: (queryData) => queryData.data,
  }).data;
  const [showing, setShowing] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (dismissed) return;

    if (
      !plan.isFree &&
      plan.isAccountOwner &&
      plan.percentOfMessagesUsed >= 75 &&
      Boolean(Number(plan.skipioPlan.automatedSmsOverageRate))
    ) {
      setShowing(true);
    }
  }, [plan.isFree, plan.percentOfMessagesUsed]);

  if (!showing) return null;

  const priceOverage = (
    Number(plan.skipioPlan.automatedSmsOverageRate) * 100
  ).toFixed(0);

  const isOver = plan.percentOfMessagesUsed >= 100;
  const body = isOver
    ? `You have used all of the monthly outbound messages included in your plan. All additional outbound messages are now being billed at ${priceOverage}￠ per message and will appear in your subscription invoice as overages. Message counts are reset at the beginning of every month.`
    : `You have used ${plan.percentOfMessagesUsed}% of the monthly outbound messages included in your plan. Messages that you send beyond what is included in your plan will be billed at ${priceOverage}￠ per outbound message. Message counts are reset at the beginning of every month.`;

  return (
    <StackingBoxModal height={400}>
      <Box elevated>
        <BoxHeader stacked white>
          <BoxTitle>
            {isOver ? (
              <>You have used all of your included messages!</>
            ) : (
              <>You have used almost all of your included messages!</>
            )}
          </BoxTitle>
          <BoxNavRight>
            <BoxNavButton
              onClick={() => {
                setShowing(false);
                setDismissed(false);
              }}
            >
              <Close />
            </BoxNavButton>
          </BoxNavRight>
        </BoxHeader>
        <BoxContent>
          <Stack>
            <Bar
              used={user.skipioPlan.monthlySmsMessagesSent}
              max={user.account.maximumMonthlySmsMessages}
              percent={plan.percentOfMessagesUsed}
            />
            <MessagesKeyframes
              messages={[
                {
                  body: `😅`,
                  duration: 1,
                },
                {
                  body,
                  duration: 1,
                },
              ]}
            />

            {plan.canUpgrade && (
              <Center>
                <Stack>
                  <Button
                    onClick={() => {
                      history.push("/app/plan");
                      setShowing(false);
                    }}
                  >
                    Upgrade to another plan
                  </Button>
                </Stack>
              </Center>
            )}
          </Stack>
        </BoxContent>
      </Box>
    </StackingBoxModal>
  );
}

const Center = styled.div`
  text-align: center;
`;
